import {Component} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../../../shared/validators/DbValidators";
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-custom-domain-add-modal',
    templateUrl: './custom-domain-add-modal.component.html',
    styleUrl: './custom-domain-add-modal.component.scss',
    standalone: false
})
export class CustomDomainAddModalComponent {
  domainForm = new FormControl("", [DbValidators.trim, Validators.required, Validators.pattern(/^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/)]);

  constructor(private _activeModal: DbActiveModal) {

  }


  onAddDomain() {
    this._activeModal.close(this.domainForm.value);
  }
}
